var swiper = new Swiper(".slider-prensa", {
    slidesPerView: "auto",
    spaceBetween: 50,
    centeredSlides: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        768: {
            centeredSlides: false,
              spaceBetween: 20,
        },
    },
    navigation: {
      nextEl: ".button-next",
      prevEl: ".button-prev"
    },
  
});



var swiper = new Swiper(".SliderCollection", {
    slidesPerView: "auto",
     spaceBetween: 40,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev"
  },

});


var swiper = new Swiper('.SwiperBanner', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },
  autoplay: {
    delay: 5500,
    disableOnInteraction: false,
  },
});


var swiper = new Swiper('.sliders-videos', {

  slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.button-next-video',
    prevEl: '.button-prev-video',
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
        centeredSlides: false,
    },
},
});


var swiper = new Swiper('.sliders-img', {
  slidesPerView: "auto",
  spaceBetween: 20,
  initialSlide: 1,
  centeredSlides: true,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },

});


var swiper = new Swiper('.sliders-reviews', {
  slidesPerView: "auto",
  loop: true,
  spaceBetween: 30,
  initialSlide: 1,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },  navigation: {
    nextEl: '.arrow-right-reviews',
    prevEl: '.arrow-left-reviews',
  },

});





var swiper = new Swiper(".slider-como-viste", {
  slidesPerView: "auto",
  spaceBetween: 30,
  centeredSlides: true,
  loop:true,
  pagination: {
      el: ".swiper-pagination",
      clickable: true,
  },
  breakpoints: {
      768: {
          centeredSlides: false,
      },
  },
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev"
  },

});



var swiper = new Swiper(".slider-section", {
  slidesPerView: "auto",
  spaceBetween: 30,
  centeredSlides: true,
  loop:true,
  pagination: {
      el: ".swiper-pagination",
      clickable: true,
  },
  breakpoints: {
      768: {
          centeredSlides: false,
      },
  },
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev"
  },

});





var swiper = new Swiper('.slider-causass', {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.arrow-right-reviews',
    prevEl: '.arrow-left-reviews',
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
},
});



    var swiper = new Swiper(".slider-servi", {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1224: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });



// var swiper = new Swiper('.sliders-beneficios', {

//   slidesPerView: 1,
//       spaceBetween: 10,

//   pagination: {
//     el: '.swiper-pagination',
//     dynamicBullets: true,
//   },
//   navigation: {
//     nextEl: '.button-next-video',
//     prevEl: '.button-prev-video',
//   },
 
//   breakpoints: {
//     640: {
//       slidesPerView: 2,
//       spaceBetween: 20,
//     },

//     768: {
//       slidesPerView: 3,
//       spaceBetween: 40,
//     },
//     1200: {
//       slidesPerView: 4,
//       spaceBetween: 40,
//     },
   
//   },
// });